import React from 'react'

// components
import Typography from 'antd/es/typography'

export const MaintenancePage = () => {
  return (
    <div className="maintenance">
      <img
        alt="maintenance"
        src={require('src/assets/images/screwdriver-wrench-solid.svg')}
      />

      <Typography.Title>
        Due to scheduled maintenance, the Emmacare portal and mobile App will
        not be available on 6/17/2023 from 9am to 11am.
      </Typography.Title>
    </div>
  )
}

export default MaintenancePage
